<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup
        v-model="dialog"
        :cons="{ title: $t('select_nfc_card') }"
        hide-confirm
        reloadable
        @reload="onReloadCons"
      >
        <template v-slot:helpinfo>
          <help-info
            :element-name="`${serviceName}-${componentName}-select-nfc-card`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('select_nfc_card')"
          />
        </template>

        <v-card class="pa-md-4" flat>
          <custom-popup
            v-model="showForm"
            :cons="{ title: $t('delivery_method') }"
            hide-confirm
            max-width="900"
          >
            <template v-slot:helpinfo>
              <help-info
                :element-name="`${serviceName}-${componentName}-select-address-send`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('delivery_method')"
              />
            </template>
            <v-card-title v-if="step === 1">
              <v-col class="py-0 px-4" cols="12">
                <v-radio-group v-model="radioGroup">
                  <v-radio value="deliverComp">
                    <template v-slot:label>
                      <v-icon left color="primary">mdi-office-building</v-icon>
                      {{ $t("delivery_at_company") }}
                    </template>
                  </v-radio>
                  <v-radio value="deliverPost">
                    <template v-slot:label>
                      <v-icon left color="primary">mdi-email</v-icon>
                      {{ $t("delivery_by_post") }}
                      <v-card-subtitle
                        class="shipping-info"
                        style="color: warning"
                      >
                        <v-icon left small color="warning">mdi-wallet</v-icon>
                        {{ $t("post_cost_and_tax_warning") }}
                      </v-card-subtitle>
                    </template>
                  </v-radio>

                  <v-row v-if="radioGroup === 'deliverPost'">
                    <v-col cols="12">
                      <v-card-title
                        style="width: 100%"
                        v-if="!!selectedRow && !!selectedRow.length"
                        class="ma-4 pa-2 rounded-lg"
                        outlined
                      >
                        {{ $t("shipping_info") }}
                      </v-card-title>
                      <v-divider class="mx-4 mt-0" />
                      <user-address-picker
                        v-model="userAddress"
                        :allow-submit.sync="canSubmit"
                      />
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-card-title>
            <v-card-actions class="justify-end pt-0 px-4" v-if="step === 1">
              <v-btn
                :disabled="radioGroup === 'deliverPost' && !canSubmit"
                :loading="loading"
                class="btn-accept ma-0"
                depressed
                @click="countinueShopping"
              >
                {{ $t("continue_shopping") }}
              </v-btn>
            </v-card-actions>
            <v-fade-transition
              v-if="
                selectedRow.length &&
                ((selectedRow[0].price > 0 && selectedRow[0].is_free === 0) ||
                  radioGroup === 'deliverPost') &&
                showForm &&
                step > 1
              "
            >
              <v-card class="rounded-lg mb-2" outlined>
                <!-- قیمت کل -->
                <div class="px-4 pt-4 d-flex align-center">
                  {{ $t("total_price") }}: (۱ عدد)
                  <v-spacer />
                  <b
                    :class="{
                      'red--text text-decoration-line-through':
                        selectedRow[0].discount !== 0,
                      'red--text': selectedRow[0].discount === 0,
                    }"
                  >
                    {{
                      use_lang(Number(selectedRow[0].price).toLocaleString())
                    }}
                  </b>
                  <span class="red--text ms-1">{{ $t("rial") }}</span>
                </div>
                <v-divider class="mb-0 mx-4 mt-4" />

                <!-- قیمت با تخفیف -->
                <div
                  v-if="selectedRow[0].discount !== 0"
                  class="px-4 pt-4 d-flex align-center"
                >
                  {{ $t("price_with_discount") }}:
                  <span class="mx-1 grey--text">
                    ({{ Math.round(selectedRow[0].discount) }}% {{ $t("off") }})
                  </span>
                  <v-spacer />
                  <b>
                    {{
                      use_lang(
                        Number(finalPrice(selectedRow[0])).toLocaleString(),
                      )
                    }}
                  </b>
                  <span class="grey--text ms-1">{{ $t("rial") }}</span>
                </div>
                <v-divider
                  v-if="selectedRow[0].discount !== 0"
                  class="mb-0 mx-4 mt-4"
                />

                <!-- هزینه ارسال -->
                <div class="px-4 pt-4 d-flex align-center">
                  {{ $t("shipping_cost_order") }}:
                  <v-spacer />
                  <b>
                    {{
                      radioGroup === "deliverPost"
                        ? use_lang(Number(790000).toLocaleString())
                        : use_lang(Number(0).toLocaleString())
                    }}
                  </b>
                  <span class="grey--text ms-1">{{ $t("rial") }}</span>
                </div>
                <v-divider class="mb-0 mx-4 mt-4" />

                <!-- سود شما -->
                <div
                  v-if="selectedRow[0].price - finalPrice(selectedRow[0]) > 0"
                  class="px-4 pt-4 d-flex align-center green--text"
                >
                  {{ $t("your_profit_from_purchase") }}:
                  <v-spacer />
                  <b>
                    {{
                      use_lang(
                        Number(
                          selectedRow[0].price - finalPrice(selectedRow[0]),
                        ).toLocaleString(),
                      )
                    }}
                  </b>
                  <span class="grey--text ms-1">{{ $t("rial") }}</span>
                </div>

                <div class="px-4 mt-4">
                  <v-alert border="left" class="white--text" color="red" dense>
                    {{ $t("ten_percent_tax_will_be_added") }}
                  </v-alert>
                </div>

                <div class="px-4 mb-4 d-flex align-center">
                  {{ $t("payable_amount") }}:
                  <v-spacer />
                  <b>{{ use_lang(Number(payableAmount).toLocaleString()) }}</b>
                  <span class="grey--text ms-1">{{ $t("rial") }}</span>
                </div>

                <div class="px-4 pb-2 d-flex align-center">
                  <v-btn
                    :disabled="step === 1"
                    :loading="loading"
                    class="w-100 mb-2"
                    outlined
                    color="green"
                    @click="placeFreeOrder"
                  >
                    <v-icon>mdi-check</v-icon>
                    {{ $t("complete_shopping") }}
                  </v-btn>
                </div>
              </v-card>
            </v-fade-transition>
          </custom-popup>

          <custom-tabs v-model="tabs" :tab-items="tabItem" grow>
            <template v-slot:helpinfo="{ tab }">
              <help-info
                v-if="tab && tab.value && tab.text"
                :element-name="`${serviceName}-${componentName}-tab-${tab.value}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${tab.text}`"
              />
            </template>
            <template v-slot:middle>
              <v-divider />
            </template>

            <template v-slot:staticItems>
              <v-tab-item class="py-4">
                <v-alert
                  type="info"
                  border="left"
                  class="white--text"
                  color="success"
                  dense
                >
                  توجه: با خرید هر یک از محصولات این صفحه، کیوآرکد سرویس شما
                  تغییر خواهد کرد. <br />در صورتی که قبلاً کیوآرکد خود را چاپ یا
                  منتشر کرده‌اید، لطفاً سفارش اختصاصی ثبت نمایید.
                  <br/><br/>
                  با تمدید بیش از یک سال میتوانید از محصولات رایگان یا محصولات با تخفیف بیش از 90% استفاده کنید.
                </v-alert>
                <v-card
                  v-if="isInitialLoad && !getError && !NotShow"
                  class="d-flex align-center justify-center"
                  flat
                  height="300"
                >
                  <atom-spinner
                    :animation-duration="1500"
                    :size="100"
                    class="mx-auto"
                    color="var(--v-primary-base)"
                  />
                </v-card>

                <v-col v-if="NotShow && !isInitialLoad" cols="12">
                  <div
                    style="
                      width: 100%;
                      border-bottom: 2px solid #ef9a9a;
                      background-color: #fff3e0;
                      color: #333333;
                      padding: 12px;
                      display: flex;
                      align-items: center;
                      gap: 8px;
                      border-radius: 8px;
                      font-size: 14px;
                    "
                  >
                    <v-icon color="#EF5350">mdi-information</v-icon>
                    {{ message }}
                  </div>
                </v-col>

                <div v-if="!NotShow && !isInitialLoad">
                  <v-row
                    no-gutters
                    class="justify-center align-center"
                    v-if="ribbon_can('managment_nfc') && info.id"
                  >
                  <managment_nfc :id="info.id"></managment_nfc>
                  </v-row>

                  <v-row no-gutters>
                    <v-col class="pa-2" cols="12" md="3">
                      <div class="rowinfo">
                        <v-select
                          v-model="tableProps.length"
                          :items="[
                            10, 25, 50, 100, 300, 500, 700, 1000, 2500, 5000,
                          ]"
                          class="rounded-lg"
                          dense
                          hide-details
                          :label="$t('count')"
                          outlined
                          @input="onInputChange"
                          @click:clear="onInputChange"
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-tableProps-length`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('count')"
                        />
                      </div>
                    </v-col>

                    <v-col class="pa-2" cols="12" md="3">
                      <div class="rowinfo">
                        <v-text-field
                          v-model="searchText"
                          @keyup.enter="searchHandler"
                          @click:append="searchHandler"
                          append-icon="mdi-magnify"
                          class="rounded-lg contentinfo"
                          clearable
                          dense
                          hide-details
                          :label="$t('search')"
                          outlined
                        />
                        <!-- @input="onInputChange"
                          @click:clear="onInputChange" -->
                        <help-info
                          :element-name="`${serviceName}-${componentName}-tableProps-search`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('search')"
                        />
                      </div>
                    </v-col>

                    <v-col class="pa-2" cols="12" md="3">
                      <div class="rowinfo">
                        <v-select
                          v-model="tableProps.orientation"
                          :items="[
                            { value: 'vertical', text: $t('vertical') },
                            {
                              value: 'horizontal',
                              text: $t('horizontal'),
                            },
                          ]"
                          :menu-props="{ offsetY: true }"
                          class="rounded-lg"
                          clearable
                          dense
                          hide-details
                          :label="$t('card_type')"
                          outlined
                          @input="onInputChange"
                          @click:clear="onInputChange"
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-tableProps-orientation`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('card_type')"
                        />
                      </div>
                    </v-col>

                    <v-col class="pa-2" cols="12" md="3">
                      <div class="rowinfo">
                        <v-text-field
                          v-model="tableProps.tags"
                          class="rounded-lg contentinfo"
                          clearable
                          dense
                          hide-details
                          :label="$t('tag')"
                          outlined
                          @input="onInputChange"
                          @click:clear="onInputChange"
                        />
                        <!-- @click:clear="onInputChange" -->
                        <!-- @input="onInputChange" -->
                        <help-info
                          :element-name="`${serviceName}-${componentName}-tableProps-tags`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('tag')"
                        />
                      </div>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col
                      v-for="(item, i) in list"
                      :key="i"
                      class="pa-3 fill-height deck-col"
                      cols="12"
                      md="4"
                    >
                      <v-card class="rounded-0" outlined>
                        <div class="pa-4 overflow-hidden text-center">
                          <div
                            :class="{
                              horizontal: item.orientation === 'horizontal',
                            }"
                            class="deck"
                          >
                            <div class="card-title-custom" v-if="item.title">
                              <FreeNfcIcon
                                v-if="item.is_free"
                                :size="23"
                                fill="#06b6d4"
                                ribbon="#ffb020"
                              />
                              <PackNfcIcon
                                v-else
                                :size="23"
                                :box="'#6366f1'"
                                :bow-left="'#ec4899'"
                              />
                              <span>{{ item.title }}</span>
                            </div>

                            <div :class="{ flipped: flipped }" class="card">
                              <div class="front face">
                                <v-img
                                  :aspect-ratio="
                                    item.orientation === 'horizontal'
                                      ? 1.615
                                      : 0.619
                                  "
                                  :src="item?.front_image"
                                  :lazy-src="
                                    item?.front_image_low_res ||
                                    item?.front_image
                                  "
                                />
                              </div>
                              <div class="back face">
                                <v-img
                                  :aspect-ratio="
                                    item.orientation === 'horizontal'
                                      ? 1.615
                                      : 0.619
                                  "
                                  :src="item?.back_image"
                                  :lazy-src="
                                    item?.back_image_low_res || item?.back_image
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- بخش نمایش قیمت ها -->
                        <v-card-text
                          class="pa-2 text-center align-center justify-center d-flex flex-column"
                        >
                          <v-card-title
                            v-if="item.is_free == 1 || item.price <= 0"
                            class="mt-0 pt-0 justify-center success--text"
                          >
                            {{ $t("free") }}
                          </v-card-title>

                          <div v-else class="w-100">
                            <v-card-subtitle
                              v-if="item.discount !== 0"
                              class="pa-0 red--text text-decoration-line-through"
                            >
                              {{
                                use_lang(Number(item.price).toLocaleString())
                              }}
                              {{ $t("currency") }}
                            </v-card-subtitle>

                            <v-card-title
                              class="mt-0 pt-0 justify-center"
                              :class="{
                                'success--text': item.discount !== 0,
                                'black--text': item.discount === 0,
                              }"
                            >
                              {{
                                use_lang(
                                  Number(finalPrice(item)).toLocaleString(),
                                )
                              }}
                              {{ $t("currency") }}
                            </v-card-title>
                          </div>
                        </v-card-text>
                      </v-card>

                      <v-card-actions class="justify-center">
                        <div class="rowinfo" style="width: 100%">
                          <v-btn
                            class="rounded-lg white--text contentinfo"
                            color="red darken-2"
                            depressed
                            @click="addNfc(item)"
                          >
                            {{ $t("select") }}
                          </v-btn>
                          <help-info
                            :element-name="`${serviceName}-${componentName}-tableProps-select`"
                            :service-name="serviceName"
                            :help-data="helpData"
                            class="buttoninfo"
                            :label="$t('select')"
                          />
                        </div>
                      </v-card-actions>
                    </v-col>
                    <template v-if="!isLastPage || loading">
                      <v-col
                        v-for="loader in 3"
                        :key="`loader-${loader}`"
                        class="pa-8"
                        cols="12"
                        md="4"
                      >
                        <v-skeleton-loader min-height="300" type="image" />
                      </v-col>
                    </template>

                    <v-col cols="12">
                      <v-card
                        v-if="!loading && !isLastPage && !getError"
                        v-intersect="onIntersect"
                        flat
                        height="200"
                      />
                    </v-col>
                  </v-row>

                  <v-card-actions class="justify-end">
                    <div class="rowinfo">
                      <v-btn
                        :disabled="!selectedRow || !selectedRow.length"
                        class="btn-accept ma-0"
                        @click="showInfo"
                      >
                        {{ $t("order_card") }}
                      </v-btn>
                      <help-info
                        :element-name="`${serviceName}-${componentName}-tableProps-selectedRow`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('order_card')"
                      />
                    </div>
                  </v-card-actions>
                </div>
              </v-tab-item>

              <v-tab-item>
                <special-nfc-order
                  v-model="specialOrderInfo"
                  :qr-id="info.id"
                  @close="dialog = false"
                />
              </v-tab-item>

              <v-tab-item>
                                <v-alert
                  type="info"
                  border="left"
                  class="white--text"
                  color="success"
                  dense
                >
                  با تمدید بیش از یک سال میتوانید از محصولات رایگان یا محصولات با تخفیف بیش از 90% استفاده کنید.
                </v-alert>

                <equipment-nfc :reset="value" :qr-id="info.id" />
              </v-tab-item>
            </template>
          </custom-tabs>
        </v-card>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import UserAddressPicker from "@/view/components/pickers/userAddressPicker.vue";
import SpecialNfcOrder from "@/view/pages/list/components/nfcList/specialNfcOrder.vue";
import { debounce } from "@/main";
import EquipmentNfc from "./components/nfcList/equipmentNfc.vue";
import PackNfcIcon from "./PackNfcIcon.vue";
import FreeNfcIcon from "./FreeNfcIcon.vue";
import managment_nfc from "./managment_nfc.vue";

export default {
  name: "qrNfcList",
  components: {
    SpecialNfcOrder,
    UserAddressPicker,
    AtomSpinner,
    EquipmentNfc,
    PackNfcIcon,
    FreeNfcIcon,
    managment_nfc,
  },
  filters: {
    orientationType(input) {
      switch (input) {
        case "vertical":
          return this.$t("vertical");
        case "horizontal":
          return this.$t("horizontal");
        default:
          return input || "-";
      }
    },
    statusType(input) {
      switch (input) {
        case "available":
          return this.$t("available");
        case "unavailable":
          return this.$t("unavailable");
        default:
          return input || "-";
      }
    },
  },
  props: {
    value: Boolean,
    address: String,
     initialType: String,
     qr_id:[String,Number],
  },
  data() {
    return {
      info:{},
      step: 1,
      allow: true,
      isInitialLoad: true,
      isFetching: false,
      NotShow: false,
      radioGroup: "deliverPost",
      helpData: [],
      serviceName: "Qrland",
      componentName: "qrNfc-list",
      data: {},
      list: [],
      searchText: "",
      selectedRow: [],
      loading: false,
      isLastPage: false,
      getError: false,
      isIntersecting: false,
      message: "",
      tableProps: {
        page: 1,
        length: 10,
        search: "",
        color: "",
        qr_type: null,
      },
      tabs: 0,
      userAddress: {
        province: null,
        city: null,
        address: null,
        postal_code: null,
      },
      canSubmit: false,
      specialOrderInfo: {
        pictures: [],
      },
      showPicture: false,
      flipped: false,
      showForm: false,
      nfcCartsCache: null,
    };
  },
  watch: {
    info: {
      handler(newVal, oldVal) {
        if (newVal && newVal.id && newVal.id !== oldVal?.id) {
          this.resetData();
          this.isInitialLoad = true;
          this.fetchNfc();
        }
      },
      deep: true,
      immediate: true,
    },
    dialog(newVal) {
      if (newVal) {
        this.tabs = 0;
        this.resetData();
        this.isInitialLoad = true;
        
        this.fetchData().then(() => {
          if (this.info && this.info.id) {
            this.fetchNfc();
          }
        });
      } else {
        this.resetData();
        this.isInitialLoad = false;
      }
    },
    },
  computed: {
        fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
    payableAmount() {
      if (
        !this.selectedRow.length ||
        this.selectedRow[0]?.price === 0 ||
        this.selectedRow[0]?.is_free == 1
      )
        return 0;
      const price = this.finalPrice(this.selectedRow[0]);
      const tax = Math.ceil(price * 0.1); // ۱۰٪ مالیات
      const shipping = this.radioGroup === "deliverPost" ? 790000 : 0;
      return price + tax + shipping;
    },
    tabItem() {
      return [
        {
          text: this.$t("select_free_nfc_card") || "",
          value: "choice-card-nfc",
        },
        {
          text: this.$t("order_custom_nfc_card") || "",
          value: "spacial-card-nfc",
        },
        { text: this.$t("buy_qr_equipment") || "", value: "spacial-card-nfc" },
      ];
    },
    NotShowDebug() {
      return this.NotShow;
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
    

  methods: {
 fetchData() {
  console.log(this.initialType,"initialType")
      this.loading = true;
    this.isLoadingDetails = true;
    console.log(this.address,"address")
    const domain = `${this.address}`;
    const endpoint = ['qrlink','clickyarseo'].includes(this.initialType?.trim()?.toLowerCase())
      ? `/v1/testQr/find1/${this.qr_id}` 
      : `/v1/testQr/find/${domain}`;

      
      return this.$api
        .get(endpoint)
        .then(({ data }) => {
          this.info = data.data;
        })      
        .finally(() => (this.loading = false));
    },
    
    countinueShopping() {
      this.step++;
      if (
        (this.selectedRow[0].price === 0 || this.selectedRow[0].is_free == 1) &&
        this.radioGroup !== "deliverPost"
      ) {
        this.placeFreeOrder();
      }
    },
    finalPrice(item) {
      if (item.price == 0 || item.is_free == 1) return 0;
      let discountRate = item.discount;
      if (discountRate > 1) {
        discountRate = discountRate / 100;
      }

      const discounted = (1 - discountRate) * item.price;
      return discounted === item.price ? item.price : discounted;
    },
    convertToEnglishDigits(input) {
      const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      const arabicDigits = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
      const englishDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

      let result = input || "";
      for (let i = 0; i < persianDigits.length; i++) {
        result = result.replace(
          new RegExp(persianDigits[i], "g"),
          englishDigits[i],
        );
      }
      for (let i = 0; i < arabicDigits.length; i++) {
        result = result.replace(
          new RegExp(arabicDigits[i], "g"),
          englishDigits[i],
        );
      }
      return result;
    },
    resetData() {
      this.list = [];
      this.data = {};
      this.selectedRow = [];
      this.isLastPage = false;
      this.getError = false;
      this.isIntersecting = false;
      this.NotShow = false;
      this.message = "";
      this.tableProps = {
        page: 1,
        length: 10,
        search: "",
        color: "",
        qr_type: null,
        qr_id:''
      };
    },
    fetchNfc(params = this.tableProps) {
      if (this.isFetching) return;

      this.isFetching = true;
      this.loading = true;
      const requestParams = { ...params };
      requestParams.qr_type = this.info.type;
      if (requestParams.tags && typeof requestParams.tags === "string") {
        requestParams.tags = requestParams.tags
          .split(",")
          .map((tag) => tag.trim())
          .filter((tag) => tag);
      } else {
        delete requestParams.tags;
      }
      const handleError = (error) => {
        const response = error.response;
        if (response?.status === 404) {
          this.NotShow = true;
          this.message =
            (this.$t && this.$t("already_have_free_nfc_message")) ||
            "You already have a free NFC card";
          if (response.errors?.status !== "delivered") {
            this.message =
              (this.$t && this.$t("nfc_in_delivery_process_message")) ||
              "NFC card is in delivery process";
          }
        }
        this.getError = true;
        this.list = [];
        this.data = {};
      };

      const finalize = () => {
        this.isInitialLoad = false;
        this.isFetching = false;
        this.loading = false;
        this.allow = false;
      };

      const handleSuccess = (nfcResponse) => {
        this.isLastPage = !nfcResponse.data.data.next_page_url;
        this.getError = false;
        this.isIntersecting = false;

        const newData = nfcResponse.data.data.data;

        if (params.page === 1) {
          this.list = [...newData];
        } else {
          this.list = [...this.list, ...newData];
        }

        const { data, ...rest } = nfcResponse.data.data;
        this.data = { ...rest };
        this.NotShow = false;
        finalize();
      };

      if (this.isInitialLoad) {
        this.$api
          .get(`/v1/testQr/check-for-nfc?qr_id=${this.info.id}`)
          .then(() => {
            requestParams.qr_id= this.info?.id;
            this.$api
              .get("/v2/nfc-carts", { params: requestParams })
              .then(handleSuccess)
              .catch((error) => {
                handleError(error);
                finalize();
              });
          })
          .catch((error) => {
            handleError(error);
            finalize();
          });
      } else {
        requestParams.qr_id= this.info.id;
        this.$api
          .get("/v2/nfc-carts", { params: requestParams })
          .then(handleSuccess)
          .catch((error) => {
            handleError(error);
            finalize();
          });
      }
    },
    showInfo() {
      const message = this.$t("free_nfc_card_warning_message");

      this.$modal.info(
        this.$t("select_card"),
        this.$t("free_card_selection_conditions"),
        message,
        {
          text: this.$t("confirm_and_select"),
          onClick: this.submitFree,
        },
        [
          {
            text: this.$t("BUTTONS.Close"),
            icon: "mdi-close",
          },
        ],
      );
    },
    submitFree() {
      this.showForm = true;
    },
    onIntersect(entries, observer) {
      this.isIntersecting = entries[0].isIntersecting;
      if (this.isIntersecting && this.list.length && !this.isLastPage) {
        this.tableProps.page++;
        this.fetchNfc();
      }
    },

    searchHandler() {
      this.tableProps.search = this.searchText;
      this.onInputChange();
    },
    onInputChange() {
      console.log("change");
      this.list = [];
      this.tableProps.page = 1;
      let search = this.convertToEnglishDigits(this.tableProps.search);
      let e = { ...this.tableProps, search, page: 1 };
      debounce(() => {
        this.fetchNfc(e);
      }, 150);
    },
    onReloadCons() {
      this.list = [];
      this.tableProps.page = 1;
      this.fetchNfc();
    },
    addNfc(item) {
      this.showForm = true;
      this.selectedRow = [{ ...item }];
    },
    placeFreeOrder() {
      this.loading = true;
      const { id } = this.selectedRow[0];

      this.$api
        .post(`/v2/select-nfc/${id}`, {
          delivery_methode:
            this.radioGroup === "deliverComp" ? "company" : "post",
          qr_id: this.info?.id,
          ...this.userAddress,
        })
        .then(({ data }) => {
          this.$toast.success(
            data.message || this.$t("registered_successfully"),
            {
              timeout: 2000,
            },
          );
          this.$emit("fetch", this.info, data.data.identifier);
          this.dialog = false;
          this.resetData();
          this.$emit("refresh-list");
        })
        .catch(({ response }) => {
          this.$toast.error(
            response?.data?.message || this.$t("error_registering_nfc_order"),
          );
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss">
.v-dialog {
  box-shadow: none !important;
}

.v-card .v-skeleton-loader,
.v-card .v-skeleton-loader .v-skeleton-loader__bone {
  height: 100%;
}

.deck-col .v-card__actions {
  visibility: hidden;
}

.deck-col:hover .v-card__actions {
  visibility: visible;  
}

.deck {
  margin: auto;
  width: 100%;
  max-width: 150px;
  height: auto;
  aspect-ratio: 0.619;
  position: relative;
  -webkit-perspective: 1000px;
  perspective: 1000px;
  border-radius: 10px;

  &.horizontal {
    aspect-ratio: 1.615;
    max-width: 95%;
  }
}

.card {
  width: 100%;
  height: 100%;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  -webkit-transition: all 0.5s linear;
  transition: all 0.5s linear;
  border-radius: 10px;
  box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.1);
}

.face {
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  background-color: whitesmoke;
  border-radius: 10px;
}

.back {
  overflow: hidden;
  z-index: -1;
  display: block;
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
  box-sizing: border-box;

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-size: 100% 100%;
    -webkit-transform: rotateY(180deg);
    -moz-transform: rotateY(180deg);
    -ms-transform: rotateY(180deg);
    -o-transform: rotateY(180deg);
    transform: rotateY(180deg);
  }
}

.front,
.back {
  transition: all 0.5s linear;
}

.front {
  z-index: 1;
}

.flipped,
.card:hover {
  box-shadow: 0 0 7px 4px rgba(0, 0, 0, 0.2);
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.free-label {
  color: #4caf50 !important;
  padding: 8px 16px;
  background: transparent !important;
  border-radius: 8px;
  display: inline-block;
}

.original-price {
  opacity: 0.7;
  margin-bottom: 4px;
}
.card-title-custom {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: inherit;
  margin-bottom: 8px;
  font-weight: bold;
}
</style>
